// removed by extract-text-webpack-plugin
module.exports = {"MenuList":"SectionMenu__MenuList__3XTfO","ActiveMenu":"SectionMenu__ActiveMenu__1NMBw"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SectionMenu/SectionMenu.css
// module id = 245
// module chunks = 0